import { useMemo } from "react";
import {
    Box,
    List,
    Typography,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import { ReactComponent as Check } from "../../public/images/user/Circle_Check.svg";
import { ReactComponent as CircleCheckWite } from "../../public/images/user/CircleCheckWite.svg";

import ReactSvgIcon from "../UIElements/ReactSvgIcon";
import {
    upperCaseRegex,
    numbersRegex,
    specialCharsRegex,
    blackListCharsRegex,
} from "../../consts";

type PasswordRequirement = {
    text: string;
    check: (pwd: string) => any;
};

type PasswordRequirementsListProps = {
    password: string;
};

export default function PasswordRequirementsList({
    password,
}: PasswordRequirementsListProps) {
    const passwordRequirements: PasswordRequirement[] = useMemo(
        () => [
            {
                text: "Contenir 14 caractères minimum",
                check: (pwd: string) => pwd.length >= 14,
            },
            {
                text: "Contenir un caractère spécial",
                check: (pwd: string) => pwd.match(specialCharsRegex),
            },
            {
                text: "Contenir un chiffre",
                check: (pwd: string) => pwd.match(numbersRegex),
            },
            {
                text: "Contenir une majuscule",
                check: (pwd: string) => pwd.match(upperCaseRegex),
            },
            {
                text: `Ne doit pas contenir l'un des caratères ( espace " ' )`,
                check: (pwd: string) => pwd.match(blackListCharsRegex),
            },
        ],
        []
    );
    return (
        <Box
            sx={{
                display: "flex",
                padding: "1rem",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "0.75rem",
                alignSelf: "stretch",
                borderRadius: "0.75rem",
                border: "1px solid #005499",
            }}
        >
            <Typography
                sx={{
                    color: "#005499",
                    fontFamily: "Roboto",
                    fontSize: "0.875rem",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "normal",
                }}
            >
                Votre mot de passe doit :
            </Typography>
            <List
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "0.75rem",
                }}
            >
                {passwordRequirements.map((item, index) => (
                    <ListItem
                        key={index}
                        disablePadding
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 0,
                            }}
                        >
                            <ReactSvgIcon
                                ReactIcon={
                                    item.check(password)
                                        ? Check
                                        : CircleCheckWite
                                }
                                reactIconProps={{
                                    width: "24px",
                                    height: "24px",
                                }}
                            />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography
                                sx={{
                                    fontFamily: "Roboto",
                                    fontSize: "0.875rem",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    lineHeight: "normal",
                                    color: "#005499",
                                }}
                            >
                                {item.text}
                            </Typography>
                        </ListItemText>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}
